/*
 * @Author: zhou lei
 * @Date: 2022-04-14 13:23:44
 * @LastEditTime: 2024-01-18 17:08:17
 * @LastEditors: zhou lei
 * @Description:
 * @FilePath: /mmeui/src/i18n/zh.js
 * 联系方式:910592680@qq.com 18669792120 科海达信息技术有限公司
 */
export default {
  login: {
    登录: '登录',
    注册: '注册',
    用户名: '用户名',
    密码: '密码',
    请选择: '请选择',
    中文: '中文',
    英文: '英文',
    用户注册: '用户注册',
    手机号: '手机号',
    验证码: '验证码',
    取消: '取 消',
    确定: '确 定',
    支付页面: '支付页面',
    获取验证码: '获取验证码'
  },
  changepwd: {
    首页: '首页',
    修改密码: '修改密码',
    用户名: '用户名',
    旧密码: '旧密码',
    新密码: '新密码',
    确认修改: '确认修改'
  },
  account: {
    首页: '首页',
    设备激活: '设备激活',
    激活码激活: '激活码激活',
    设备编号: '设备编号',
    激活码: '激活码',
    激活账号: '激活账号',
    批量激活: '批量激活',
    选择文件: '选择文件',
    开始上传: '开始上传',
    下载导入模板: '下载导入模板',
    信息提示: '信息提示',
    当前限制选择1个文件: '当前限制选择1个文件',
    本次选择了: '本次选择了',
    个文件: '个文件',
    共选择了: '共选择了'
  },
  map: {
    首页: '首页',
    地图: '地图',
    开始日期: '开始日期',
    至: '至',
    结束日期: '结束日期',
    确定: '确定',
    显示卫星图: '显示卫星图',
    设备名称: '设备名称',
    经纬度: '经纬度',
    时间: '时间',
    '1/3波高': '1/3波高',
    '1/3波周期': '1/3波周期',
    '1/10波高': '1/10波高',
    '1/10波周期': '1/10波周期',
    最大波高: '最大波高',
    最大波周期: '最大波周期',
    平均波高: '平均波高',
    平均波周期: '平均波周期',
    涌浪波高: '涌浪波高',
    涌浪波周期: '涌浪波周期',
    波向: '波向',
    电压值: '电压值',
    温度: '温度',
    '1/3 Wave Height(m)': '1/3 Wave Height(m)',
    '1/3 Wave Period(s)': '1/3 Wave Period(s)',
    '1/10 Wave Height(m)': '1/10 Wave Height(m)',
    '1/10 Wave Period(s)': '1/10 Wave Period(s)',
    'Max Wave Height(m)': 'Max Wave Height(m)',
    'Max Wave Period(s)': 'Max Wave Period(s)',
    'Mean Wave Height (m)': 'Mean Wave Height (m)',
    'Mean Wave Period (s)': 'Mean Wave Period (s)',
    'Surge Wave Height (m)': 'Surge Wave Height (m)',
    'Surge Wave Period (s)': 'Surge Wave Period (s)',
    'Wave Direction': 'Wave Direction',
    'Surface Temp (℃)': 'Surface Temp (℃)',
    'voltage value (V)': 'voltage value (V)',
    'Wind Direction': 'Wind Direction',
    'Wind Speed (m/s)': 'Wind Speed (m/s)',
    'Air Pressure(hPa)': 'Air Pressure(hPa)',
    'Relative humidity': 'Relative humidity',
    'Temp(℃)': 'Temp(℃)',
    'Currents Velocity01(mm/s)': 'Currents Velocity01(mm/s)',
    'Currents Velocity02(mm/s)': 'Currents Velocity02(mm/s)',
    'Currents Velocity03(mm/s)': 'Currents Velocity03(mm/s)',
    'Currents Velocity04(mm/s)': 'Currents Velocity04(mm/s)',
    'Currents Velocity05(mm/s)': 'Currents Velocity05(mm/s)',
    'Currents Velocity06(mm/s)': 'Currents Velocity06(mm/s)',
    'Currents Velocity07(mm/s)': 'Currents Velocity07(mm/s)',
    'Currents Velocity08(mm/s)': 'Currents Velocity08(mm/s)',
    'Currents Velocity09(mm/s)': 'Currents Velocity09(mm/s)',
    'Currents Velocity10(mm/s)': 'Currents Velocity10(mm/s)',
    'Currents Velocity11(mm/s)': 'Currents Velocity11(mm/s)',
    'Currents Velocity12(mm/s)': 'Currents Velocity12(mm/s)',
    'Currents Velocity13(mm/s)': 'Currents Velocity13(mm/s)',
    'Currents Velocity14(mm/s)': 'Currents Velocity14(mm/s)',
    'Currents direction01(°)': 'Currents direction01(°)',
    'Currents direction02(°)': 'Currents direction02(°)',
    'Currents direction03(°)': 'Currents direction03(°)',
    'Currents direction04(°)': 'Currents direction04(°)',
    'Currents direction05(°)': 'Currents direction05(°)',
    'Currents direction06(°)': 'Currents direction06(°)',
    'Currents direction07(°)': 'Currents direction07(°)',
    'Currents direction08(°)': 'Currents direction08(°)',
    'Currents direction09(°)': 'Currents direction09(°)',
    'Currents direction10(°)': 'Currents direction10(°)',
    'Currents direction11(°)': 'Currents direction11(°)',
    'Currents direction12(°)': 'Currents direction12(°)',
    'Currents direction13(°)': 'Currents direction13(°)',
    'Currents direction14(°)': 'Currents direction14(°)'
  },
  detail: {
    首页: '首页',
    测试页面: '测试页面',
    配置参数: '配置参数',
    设备名: '设备名',
    设备编号: '设备编号',
    设备名称: '设备名称',
    北斗更新时间: '北斗更新时间',
    整点: '(整点)',
    时间: '时间',
    偏移量: '偏移量',
    米: '(米)',
    终端采样频率: '终端采样频率',
    分: '(分)',
    基准纬度: '基准纬度',
    度: '(度)',
    基准经度: '基准经度',
    无信号报警间隔: '无信号报警间隔',
    报警刷新时间: '报警刷新时间',
    查看: '查看',
    偏移报警: '偏移报警',
    超时报警: '超时报警',
    开舱漏水报警: '开舱漏水报警',
    保存: '保存',
    设备可见用户: '设备可见用户',
    添加可见用户: '添加可见用户',
    移除共享: '移除共享',
    设备数据: '设备数据',
    开始日期: '开始日期',
    至: '至',
    结束日期: '结束日期',
    确定: '确定',
    经度: '经度',
    纬度: '纬度',
    设备报表下载: '设备报表下载',
    添加可访问用户: '添加可访问用户',
    设备编码: '设备编码',
    用户名: '用户名',
    手机号: '手机号',
    取消: '取 消',
    报警列表: '报警列表',
    设备信息表ID: '设备信息表ID',
    设备类型ID: '设备类型ID',
    GPS时间: 'GPS时间',
    一路温度: '一路温度',
    二路温度: '二路温度',
    三路温度: '三路温度',
    一路湿度: '一路湿度',
    二路湿度: '二路湿度',
    三路湿度: '三路湿度',
    是否开仓: '是否开仓',
    是: '是',
    否: '否',
    操作: '操作',
    已读: '已读',
    选择了: '选择了',
    操作失败: '操作失败',
    报警信息提示: '报警信息提示',
    修改操作成功: '修改操作成功',
    保存成功: '保存成功',
    保存失败: '保存失败',
    这是一段内容: '这是一段内容',
    标题名称: '标题名称',
    查询数据超过6万条: '查询数据超过6万条，正在下载前6万条数据',

    风速: '风速',
    盐度: '盐度',
    气压: '气压',
    波高: '波高',
    温度: '温度',
    波值: '波值',
    波周期: '波周期',
    波向: '波向',
    电压值: '电压值',
    风向: '风向',
    '1/3波高': '1/3波高',
    '1/3波周期': '1/3波周期',
    '1/10波高': '1/10波高',
    '1/10波周期': '1/10波周期',
    最大波高: '最大波高',
    最大波周期: '最大波周期',
    平均波高: '平均波高',
    平均波周期: '平均波周期',
    涌浪波高: '涌浪波高',
    涌浪波周期: '涌浪波周期',
    'CTD温度℃': 'CTD温度℃',
    'CTD电导率S/m': 'CTD电导率S/m',
    CTD盐度PSU: 'CTD盐度PSU',
    'ADCP温度℃': 'ADCP温度℃',
    'E/W-mm/s': 'E/W-mm/s',
    'N/S-mm/s': 'N/S-mm/s',
    Vert: 'Vert',
    CR采集器温度: 'CR采集器温度',
    CR空气温度avg: 'CR空气温度avg',
    CR空气湿度avg: 'CR空气湿度avg',
    CR水汽压avg: 'CR水汽压avg',
    CR气压avg: 'CR气压avg',
    CR相对风速avg: 'CR相对风速avg',
    CR相对风向avg: 'CR相对风向avg',
    'CR实际风速avg（knots）': 'CR实际风速avg（knots）',
    'CR实际风速avg（m/s）': 'CR实际风速avg（m/s）',
    'CR实际风向avg（°）': 'CR实际风向avg（°）',
    CR长波辐射avg: 'CR长波辐射avg',
    CR总辐射avg: 'CR总辐射avg',
    CR总辐射acc: 'CR总辐射acc',
    CR雨量acc: 'CR雨量acc',
    GMX风向: 'GMX风向',
    GMX风速: 'GMX风速',
    GMX校正后风向: 'GMX校正后风向',
    GMX气压: 'GMX气压',
    GMX相对湿度: 'GMX相对湿度',
    GMX温度: 'GMX温度',
    GMX露点温度: 'GMX露点温度',
    GMX雨量: 'GMX雨量',
    GMX降雨密度: 'GMX降雨密度',
    温度0: '温度0',
    经度1: '经度1',
    纬度1: '纬度1',
    温度1: '温度1',
    经度2: '经度2',
    纬度2: '纬度2',
    温度2: '温度2',
    经度3: '经度3',
    纬度3: '纬度3',
    温度3: '温度3',
    经度4: '经度4',
    纬度4: '纬度4',
    温度4: '温度4',
    信息编号: '信息编号',
    CTD压力db: 'CTD压力db',
    GMX校正后风速: 'GMX校正后风速',
    GMX风向avg: 'GMX风向avg',
    GMX风速avg: 'GMX风速avg',
    GMX校正后风向avg: 'GMX校正后风向avg',
    GMX校正后风速avg: 'GMX校正后风速avg',
    GMX平均纬度整数: 'GMX平均纬度整数',
    GMX平均纬度分数: 'GMX平均纬度分数',
    GMX平均经度整数: 'GMX平均经度整数',
    GMX平均经度分数: 'GMX平均经度分数',
    GMX平均海拔: 'GMX平均海拔',
    GMX总雨量: 'GMX总雨量',
    GMX经度: 'GMX经度',
    GMX纬度: 'GMX纬度',
    GMX海拔: 'GMX海拔',
    'E/W1-mm/s': 'E/W1-mm/s',
    'E/W2-mm/s': 'E/W2-mm/s',
    'E/W3-mm/s': 'E/W3-mm/s',
    'E/W4-mm/s': 'E/W4-mm/s',
    'E/W5-mm/s': 'E/W5-mm/s',
    'E/W6-mm/s': 'E/W6-mm/s',
    'E/W7-mm/s': 'E/W7-mm/s',
    'N/S1-mm/s': 'N/S1-mm/s',
    'N/S2-mm/s': 'N/S2-mm/s',
    'N/S3-mm/s': 'N/S3-mm/s',
    'N/S4-mm/s': 'N/S4-mm/s',
    'N/S5-mm/s': 'N/S5-mm/s',
    'N/S6-mm/s': 'N/S6-mm/s',
    'N/S7-mm/s': 'N/S7-mm/s',
    VERT1: 'VERT1',
    VERT2: 'VERT2',
    VERT3: 'VERT3',
    VERT4: 'VERT4',
    VERT5: 'VERT5',
    VERT6: 'VERT6',
    VERT7: 'VERT7',
    ERR1: 'ERR1',
    ERR2: 'ERR2',
    ERR3: 'ERR3',
    ERR4: 'ERR4',
    ERR5: 'ERR5',
    ERR6: 'ERR6',
    ERR7: 'ERR7',
    ECHO11: 'ECHO11',
    ECHO12: 'ECHO12',
    ECHO13: 'ECHO13',
    ECHO14: 'ECHO14',
    ECHO15: 'ECHO15',
    ECHO16: 'ECHO16',
    ECHO17: 'ECHO17',
    ECHO21: 'ECHO21',
    ECHO22: 'ECHO22',
    ECHO23: 'ECHO23',
    ECHO24: 'ECHO24',
    ECHO25: 'ECHO25',
    ECHO26: 'ECHO26',
    ECHO27: 'ECHO27',
    ECHO31: 'ECHO31',
    ECHO32: 'ECHO32',
    ECHO33: 'ECHO33',
    ECHO34: 'ECHO34',
    ECHO35: 'ECHO35',
    ECHO36: 'ECHO36',
    ECHO37: 'ECHO37',
    ECHO41: 'ECHO41',
    ECHO42: 'ECHO42',
    ECHO43: 'ECHO43',
    ECHO44: 'ECHO44',
    ECHO45: 'ECHO45',
    ECHO46: 'ECHO46',
    ECHO47: 'ECHO47',
    包号: '包号',
    谱峰周期: '谱峰周期',
    机械风风速: '机械风风速',
    机械风风向: '机械风风向',
    PWD20能见度: 'PWD20能见度',
    PWD20降水强度: 'PWD20降水强度',
    PTB210压力hPa: 'PTB210压力hPa',
    'SPP短波辐射Wm^-2': 'SPP短波辐射Wm^-2',
    'PIR长波辐射Wm^-2': 'PIR长波辐射Wm^-2',
    '50203雨量mm': '50203雨量mm',
    'HMP温度℃': 'HMP温度℃',
    'HMP湿度%RH': 'HMP湿度%RH',
    'CO2-ppm': 'CO2-ppm',
    'E/W8-mm/s': 'E/W8-mm/s',
    'E/W9-mm/s': 'E/W9-mm/s',
    'E/W11-mm/s': 'E/W11-mm/s',
    'E/W10-mm/s': 'E/W10-mm/s',
    'E/W12-mm/s': 'E/W12-mm/s',
    'E/W13-mm/s': 'E/W13-mm/s',
    'E/W14-mm/s': 'E/W14-mm/s',
    'E/W15-mm/s': 'E/W15-mm/s',
    'E/W16-mm/s': 'E/W16-mm/s',
    'E/W17-mm/s': 'E/W17-mm/s',
    'E/W18-mm/s': 'E/W18-mm/s',
    'E/W19-mm/s': 'E/W19-mm/s',
    'E/W20-mm/s': 'E/W20-mm/s',
    'N/S8-mm/s': 'N/S8-mm/s',
    'N/S9-mm/s': 'N/S9-mm/s',
    'N/S11-mm/s': 'N/S11-mm/s',
    'N/S10-mm/s': 'N/S10-mm/s',
    'N/S12-mm/s': 'N/S12-mm/s',
    'N/S13-mm/s': 'N/S13-mm/s',
    'N/S14-mm/s': 'N/S14-mm/s',
    'N/S15-mm/s': 'N/S15-mm/s',
    'N/S16-mm/s': 'N/S16-mm/s',
    'N/S17-mm/s': 'N/S17-mm/s',
    'N/S18-mm/s': 'N/S18-mm/s',
    'N/S19-mm/s': 'N/S19-mm/s',
    'N/S20-mm/s': 'N/S20-mm/s',
    DH22温度: 'DH22温度',
    DH22湿度: 'DH22湿度',
    pH: 'pH',
    'HDO(%Sat)': 'HDO(%Sat)',
    P波向: 'P波向',
    A波向: 'A波向',
    TD01温度: 'TD01温度',
    TD01压力: 'TD01压力',
    TD02温度: 'TD02温度',
    TD02压力: 'TD02压力',
    TD03温度: 'TD03温度',
    TD03压力: 'TD03压力',
    TD04温度: 'TD04温度',
    TD04压力: 'TD04压力',
    TD05温度: 'TD05温度',
    TD05压力: 'TD05压力',
    TD06温度: 'TD06温度',
    TD06压力: 'TD06压力',
    TD07温度: 'TD07温度',
    TD07压力: 'TD07压力',
    TD08温度: 'TD08温度',
    TD08压力: 'TD08压力',
    TD09温度: 'TD09温度',
    TD09压力: 'TD09压力',
    TD10温度: 'TD10温度',
    TD10压力: 'TD10压力',
    CTD01温度: 'CTD01温度',
    CTD01电导率: 'CTD01电导率',
    CTD01压力: 'CTD01压力',
    CTD02温度: 'CTD02温度',
    CTD02电导率: 'CTD02电导率',
    CTD02压力: 'CTD02压力',
    CTD03温度: 'CTD03温度',
    CTD03电导率: 'CTD03电导率',
    CTD03压力: 'CTD03压力',
    CTD04温度: 'CTD04温度',
    CTD04电导率: 'CTD04电导率',
    CTD04压力: 'CTD04压力',
    CTD05温度: 'CTD05温度',
    CTD05电导率: 'CTD05电导率',
    CTD05压力: 'CTD05压力',
    'NORTEK-E-speed': 'NORTEK-E-speed',
    'NORTEK-N-speed': 'NORTEK-N-speed',
    'NORTEK-U-speed': 'NORTEK-U-speed',
    'NORTEK-BEAM1': 'NORTEK-BEAM1',
    'NORTEK-BEAM2': 'NORTEK-BEAM2',
    'NORTEK-BEAM3': 'NORTEK-BEAM3',
    'NORTEK-PRESS': 'NORTEK-PRESS',
    'NORTEK-TEMP': 'NORTEK-TEMP',
    'NORTEK-SPEED': 'NORTEK-SPEED',
    'NORTEK-DIR': 'NORTEK-DIR',
    水下CO2: '水下CO2',
    '水下CO2-ppm': '水下CO2-ppm',
    '水上CO2-μmol/mol': '水上CO2-μmol/mol',
    水听器01: '水听器01',
    水听器02: '水听器02',
    水听器03: '水听器03',
    水听器04: '水听器04',
    水听器05: '水听器05',
    水听器06: '水听器06',
    水听器07: '水听器07',
    水听器08: '水听器08',
    水听器09: '水听器09',
    水听器10: '水听器10',
    水听器11: '水听器11',
    水听器12: '水听器12',
    水听器13: '水听器13',
    水听器14: '水听器14',
    水听器15: '水听器15',
    水听器16: '水听器16',
    水听器17: '水听器17',
    水听器18: '水听器18',
    水听器19: '水听器19',
    水听器20: '水听器20',
    水听器21: '水听器21',
    水听器22: '水听器22',
    水听器23: '水听器23',
    水听器24: '水听器24',
    水听器25: '水听器25',
    水听器26: '水听器26',
    水听器27: '水听器27',
    水听器28: '水听器28',
    '高程（米）': '高程（米）',
    pitch: 'pitch',
    roll: 'roll',
    'X流速cm/s': 'X流速cm/s',
    'Y流速cm/s': 'Y流速cm/s',
    '流速cm/s': '流速cm/s',
    '方位°': '方位°',
    '流向°': '流向°',
    'N/S流速cm/s': 'N/S流速cm/s',
    'E/W流速cm/s': 'E/W流速cm/s',
    保留字段: '保留字段',
    '溶解氧（mg/L）': '溶解氧（mg/L）',
    '液位值（mm）': '液位值（mm）',
    硝酸盐: '硝酸盐',
    亚硝酸盐: '亚硝酸盐',
    氨氮: '氨氮',
    磷酸盐: '磷酸盐',
    硅酸盐: '硅酸盐',
    硝酸盐I0: '硝酸盐I0',
    硝酸盐I1: '硝酸盐I1',
    亚硝酸盐I0: '亚硝酸盐I0',
    亚硝酸盐I1: '亚硝酸盐I1',
    氨氮I0: '氨氮I0',
    氨氮I1: '氨氮I1',
    磷酸盐I0: '磷酸盐I0',
    磷酸盐I1: '磷酸盐I1',
    硅酸盐I0: '硅酸盐I0',
    硅酸盐I1: '硅酸盐I1',
    bWeek: 'bWeek',
    bTow: 'bTow',
    bLon: 'bLon',
    bLat: 'bLat',
    bH: 'bH',
    bWaveH: 'bWaveH',
    bWaveT: 'bWaveT',
    bZtd: 'bZtd',
    TD11温度: 'TD11温度',
    TD11压力: 'TD11压力',
    TD12温度: 'TD12温度',
    TD12压力: 'TD12压力',
    TD13温度: 'TD13温度',
    TD13压力: 'TD13压力',
    TD14温度: 'TD14温度',
    TD14压力: 'TD14压力',
    TD15温度: 'TD15温度',
    TD15压力: 'TD15压力',
    TD16温度: 'TD16温度',
    TD16压力: 'TD16压力',
    TD17温度: 'TD17温度',
    TD17压力: 'TD17压力',
    TD18温度: 'TD18温度',
    TD18压力: 'TD18压力',
    TD19温度: 'TD19温度',
    TD19压力: 'TD19压力',
    TD20温度: 'TD20温度',
    TD20压力: 'TD20压力',
    TD21温度: 'TD21温度',
    TD21压力: 'TD21压力',
    TD22温度: 'TD22温度',
    TD22压力: 'TD22压力',
    TD23温度: 'TD23温度',
    TD23压力: 'TD23压力',
    TD24温度: 'TD24温度',
    TD24压力: 'TD24压力',
    TD25温度: 'TD25温度',
    TD25压力: 'TD25压力',
    TD26温度: 'TD26温度',
    TD26压力: 'TD26压力',
    TD27温度: 'TD27温度',
    TD27压力: 'TD27压力',
    TD28温度: 'TD28温度',
    TD28压力: 'TD28压力',
    TD29温度: 'TD29温度',
    TD29压力: 'TD29压力',
    TD30温度: 'TD30温度',
    TD30压力: 'TD30压力',
    TD31温度: 'TD31温度',
    TD31压力: 'TD31压力',
    TD32温度: 'TD32温度',
    TD32压力: 'TD32压力',
    TD33温度: 'TD33温度',
    TD33压力: 'TD33压力',
    TD34温度: 'TD34温度',
    TD34压力: 'TD34压力',
    TD35温度: 'TD35温度',
    TD35压力: 'TD35压力',
    表层温度: '表层温度',
    表层盐度: '表层盐度',
    波向02: '波向02',
    '水深01（m）': '水深01（m）',
    '水深02（m）': '水深02（m）',
    定位状态: '定位状态',
    报表: '报表',
    请完善查询条件: '请完善查询条件',
    北礵三米测浪浮标: '北礵三米测浪浮标',
    时间1: '时间',
    气压1: '气压',
    波高1: '波高',
    波周期1: '波周期',
    '24h最大': '24h最大',
    最大风速: '最大风速',
    最大风向: '最大风向',
    '24h最大波高': '24h最大波高',
    最新: '最新',
    时间2: '时间',
    时间3: '时间3',
    '波高0~1米': '波高0~1米',
    '波高1~2米': '波高1~2米',
    '波高2~3米': '波高2~3米',
    海洋监测系统动态数据显示平台: '海洋监测系统动态数据显示平台'
    // "波向":"wave direction",
    // "时间":"date time",
    // "最新":"up to date",
    // "时间":"Date &Time",
    // "风速":"wind speed",
    // "风向":"wind direction",
  },
  detailen: {
    首页: 'Home',
    测试页面: 'Test Page',
    配置参数: 'Configuration Parameters',
    设备名: 'Device Name',
    设备编号: 'Device Number',
    设备名称: 'Device ',
    北斗更新时间: 'Beidou Update Time',
    整点: `(o'clock)`,
    时间: 'Time',
    偏移量: 'Offset',
    米: '(Metre)',
    终端采样频率: 'Terminal Sampling Frequency',
    分: '(Minute)',
    基准纬度: 'Standard Latitude',
    度: '(Degree)',
    基准经度: 'Standard longitude',
    无信号报警间隔: 'No signal alarm interval',
    报警刷新时间: 'Alarm Refresh Time',
    查看: 'View',
    偏移报警: 'Offset Alarm',
    超时报警: 'Timeout Alarm',
    开舱漏水报警: 'Open cabin water leakage alarm',
    保存: 'Save',
    设备可见用户: 'Users with viewing permission',
    添加可见用户: 'Add a user with viewing permission',
    移除共享: 'Remove Sharing',
    设备数据: 'Device Data',
    开始日期: 'Start Date',
    至: 'to',
    结束日期: 'End Date',
    确定: 'Confirm',
    经度: 'Longitude',
    纬度: 'Latitude',
    设备报表下载: 'Device Report Download',
    添加可访问用户: 'Add Accessible Users',
    设备编码: 'Device Code',
    用户名: 'Username',
    手机号: 'Tel',
    取消: 'Cancel',
    报警列表: 'Alarm List',
    设备信息表ID: 'Device Information Digram ID',
    设备类型ID: 'Device Type ID',
    GPS时间: 'GPS Time',
    一路温度: 'One-Way Temperature',
    二路温度: 'Two-Way Temperature',
    三路温度: 'Three-Way Temperature',
    一路湿度: 'One-Way Humidity',
    二路湿度: 'Two-Way Humidity',
    三路湿度: 'Three-Way Humidity',
    是否开仓: 'Open Cabin?',
    是: 'Yes',
    否: 'No',
    操作: 'operate',
    已读: 'Read',
    选择了: 'You have selected',
    操作失败: 'Operation Failed',
    报警信息提示: 'Prompt Alarm',
    修改操作成功: 'The modification operation succeeded',
    保存成功: 'Successfully saved',
    保存失败: 'Failed to save',
    这是一段内容: 'Content',
    标题名称: 'Title',
    查询数据超过6万条: 'More than 60,000 records, the first 60,000 records are being downloaded',
    风速: 'Wind Speed',
    盐度: 'Salinity',
    气压: 'Atmospheric Pressure',
    波高: 'Wave Height',
    温度: 'Temperature',
    波值: 'Wave Value',
    波周期: 'Wave Period',
    波向: 'Wave Direction',
    电压值: 'Voltage Value',
    风向: 'Wind Direction',
    '1/3波高': '1/3 Wave Height',
    '1/3波周期': '1/3 Wave Period',
    '1/10波高': '1/10 Wave Height',
    '1/10波周期': '1/10 Wave Period',
    最大波高: 'Maximum Wave Height',
    最大波周期: 'Maximum Wave Period',
    平均波高: 'Mean Wave Height',
    平均波周期: 'Mean Wave Period',
    涌浪波高: 'Surge Wave Height',
    涌浪波周期: 'Surge Wave Period',
    'CTD温度℃': 'CTD Temperature ℃',
    'CTD电导率S/m': 'CTD Conductivity S/m',
    CTD盐度PSU: 'CTD Salinity PSU',
    'ADCP温度℃': 'ADCP Temperature ℃',
    'E/W-mm/s': 'E/W-mm/s',
    'N/S-mm/s': 'N/S-mm/s',
    Vert: 'Vert',
    CR采集器温度: 'CR Collector temperature',
    CR空气温度avg: 'CR Air Temperature avg',
    CR空气湿度avg: 'CR Air Humidity avg',
    CR水汽压avg: 'CR Water Vapor Pressure avg',
    CR气压avg: 'CR Atmospheric Pressure avg',
    CR相对风速avg: 'CR Relative Wind Speed avg',
    CR相对风向avg: 'CR Relative Wind Direction avg',
    'CR实际风速avg（knots）': 'CR Actual Wind Speed avg（knots）',
    'CR实际风速avg（m/s）': 'CR Actual Wind Speed avg（m/s）',
    'CR实际风向avg（°）': 'CR Actual Wind Direction avg（°）',
    CR长波辐射avg: 'CR Longwave Radiation avg',
    CR总辐射avg: 'CR Total Radiation avg',
    CR总辐射acc: 'CR Total Radiation acc',
    CR雨量acc: 'CR Rainfall acc',
    GMX风向: 'GMX Wind Direction',
    GMX风速: 'GMX Wind Speed',
    GMX校正后风向: 'GMX Wind Direction After Correction',
    GMX气压: 'GMX Atmospheric Pressure',
    GMX相对湿度: 'GMX Relative Humidity',
    GMX温度: 'GMX Temperature',
    GMX露点温度: 'GMX Dew Point Temperature',
    GMX雨量: 'GMX Rainfall',
    GMX降雨密度: 'GMX Rainfall Density',
    温度0: 'Temperature 0',
    经度1: 'Longitude 1',
    纬度1: 'Latitude 1',
    温度1: 'Temperature 1',
    经度2: 'Longitude 2',
    纬度2: 'Latitude 2',
    温度2: 'Temperature 2',
    经度3: 'Longitude 3',
    纬度3: 'Latitude 3',
    温度3: 'Temperature 3',
    经度4: 'Longitude 4',
    纬度4: 'Latitude 4',
    温度4: 'Temperature 4',
    信息编号: 'Message Numver',
    CTD压力db: 'CTD Pressure db',
    GMX校正后风速: 'GMX Wind Speed After Correction',
    GMX风向avg: 'GMX Wind Direction avg',
    GMX风速avg: 'GMX Wind Speed avg',
    GMX校正后风向avg: 'GMX Wind Direction After Correction avg',
    GMX校正后风速avg: 'GMX Wind Speed After Correction avg',
    GMX平均纬度整数: 'GMX Mean Latitude Degree',
    GMX平均纬度分数: 'GMX Mean Latitude Minute',
    GMX平均经度整数: 'GMX Mean Longitude Degree',
    GMX平均经度分数: 'GMX Mean Longitude Minute',
    GMX平均海拔: 'GMX Average Altitude',
    GMX总雨量: 'GMX Total Rainfall',
    GMX经度: 'GMX Longitude',
    GMX纬度: 'GMX Latitude',
    GMX海拔: 'GMX Altitude',
    'E/W1-mm/s': 'E/W1-mm/s',
    'E/W2-mm/s': 'E/W2-mm/s',
    'E/W3-mm/s': 'E/W3-mm/s',
    'E/W4-mm/s': 'E/W4-mm/s',
    'E/W5-mm/s': 'E/W5-mm/s',
    'E/W6-mm/s': 'E/W6-mm/s',
    'E/W7-mm/s': 'E/W7-mm/s',
    'N/S1-mm/s': 'N/S1-mm/s',
    'N/S2-mm/s': 'N/S2-mm/s',
    'N/S3-mm/s': 'N/S3-mm/s',
    'N/S4-mm/s': 'N/S4-mm/s',
    'N/S5-mm/s': 'N/S5-mm/s',
    'N/S6-mm/s': 'N/S6-mm/s',
    'N/S7-mm/s': 'N/S7-mm/s',
    VERT1: 'VERT1',
    VERT2: 'VERT2',
    VERT3: 'VERT3',
    VERT4: 'VERT4',
    VERT5: 'VERT5',
    VERT6: 'VERT6',
    VERT7: 'VERT7',
    ERR1: 'ERR1',
    ERR2: 'ERR2',
    ERR3: 'ERR3',
    ERR4: 'ERR4',
    ERR5: 'ERR5',
    ERR6: 'ERR6',
    ERR7: 'ERR7',
    ECHO11: 'ECHO11',
    ECHO12: 'ECHO12',
    ECHO13: 'ECHO13',
    ECHO14: 'ECHO14',
    ECHO15: 'ECHO15',
    ECHO16: 'ECHO16',
    ECHO17: 'ECHO17',
    ECHO21: 'ECHO21',
    ECHO22: 'ECHO22',
    ECHO23: 'ECHO23',
    ECHO24: 'ECHO24',
    ECHO25: 'ECHO25',
    ECHO26: 'ECHO26',
    ECHO27: 'ECHO27',
    ECHO31: 'ECHO31',
    ECHO32: 'ECHO32',
    ECHO33: 'ECHO33',
    ECHO34: 'ECHO34',
    ECHO35: 'ECHO35',
    ECHO36: 'ECHO36',
    ECHO37: 'ECHO37',
    ECHO41: 'ECHO41',
    ECHO42: 'ECHO42',
    ECHO43: 'ECHO43',
    ECHO44: 'ECHO44',
    ECHO45: 'ECHO45',
    ECHO46: 'ECHO46',
    ECHO47: 'ECHO47',
    包号: 'Datagram Number',
    谱峰周期: 'Spectral Peak Period',
    机械风风速: 'Mechanical Wind Speed',
    机械风风向: 'Mechanical Wind Direction',
    PWD20能见度: 'PWD20 Visibility',
    PWD20降水强度: 'PWD20 Precipitation Intensity',
    PTB210压力hPa: 'PTB210 Pressure hPa',
    'SPP短波辐射Wm^-2': 'SPP Shortwave Radiation Wm^-2',
    'PIR长波辐射Wm^-2': 'PIR Longwave Radiation Wm^-2',
    '50203雨量mm': '50203 Rainfall mm',
    'HMP温度℃': 'HMP Temperature ℃',
    'HMP湿度%RH': 'HMP Humidity %RH',
    'CO2-ppm': 'CO2-ppm',
    'E/W8-mm/s': 'E/W8-mm/s',
    'E/W9-mm/s': 'E/W9-mm/s',
    'E/W11-mm/s': 'E/W11-mm/s',
    'E/W10-mm/s': 'E/W10-mm/s',
    'E/W12-mm/s': 'E/W12-mm/s',
    'E/W13-mm/s': 'E/W13-mm/s',
    'E/W14-mm/s': 'E/W14-mm/s',
    'E/W15-mm/s': 'E/W15-mm/s',
    'E/W16-mm/s': 'E/W16-mm/s',
    'E/W17-mm/s': 'E/W17-mm/s',
    'E/W18-mm/s': 'E/W18-mm/s',
    'E/W19-mm/s': 'E/W19-mm/s',
    'E/W20-mm/s': 'E/W20-mm/s',
    'N/S8-mm/s': 'N/S8-mm/s',
    'N/S9-mm/s': 'N/S9-mm/s',
    'N/S11-mm/s': 'N/S11-mm/s',
    'N/S10-mm/s': 'N/S10-mm/s',
    'N/S12-mm/s': 'N/S12-mm/s',
    'N/S13-mm/s': 'N/S13-mm/s',
    'N/S14-mm/s': 'N/S14-mm/s',
    'N/S15-mm/s': 'N/S15-mm/s',
    'N/S16-mm/s': 'N/S16-mm/s',
    'N/S17-mm/s': 'N/S17-mm/s',
    'N/S18-mm/s': 'N/S18-mm/s',
    'N/S19-mm/s': 'N/S19-mm/s',
    'N/S20-mm/s': 'N/S20-mm/s',
    DH22温度: 'DH22 Temperature',
    DH22湿度: 'DH22 Humidity',
    pH: 'pH',
    'HDO(%Sat)': 'HDO(%Sat)',
    P波向: 'P Wave Direction ',
    A波向: 'A Wave Direction ',
    TD01温度: 'TD01 Temperature',
    TD01压力: 'TD01 Pressure',
    TD02温度: 'TD02 Temperature',
    TD02压力: 'TD02 Pressure',
    TD03温度: 'TD03 Temperature',
    TD03压力: 'TD03 Pressure',
    TD04温度: 'TD04 Temperature',
    TD04压力: 'TD04 Pressure',
    TD05温度: 'TD05 Temperature',
    TD05压力: 'TD05 Pressure',
    TD06温度: 'TD06 Temperature',
    TD06压力: 'TD06 Pressure',
    TD07温度: 'TD07 Temperature',
    TD07压力: 'TD07 Pressure',
    TD08温度: 'TD08 Temperature',
    TD08压力: 'TD08 Pressure',
    TD09温度: 'TD09 Temperature',
    TD09压力: 'TD09 Pressure',
    TD10温度: 'TD10 Temperature',
    TD10压力: 'TD10 Pressure',
    CTD01温度: 'CTD01 Temperature',
    CTD01电导率: 'CTD01 Conductivity',
    CTD01压力: 'CTD01 Pressure',
    CTD02温度: 'CTD02 Temperature',
    CTD02电导率: 'CTD02 Conductivity',
    CTD02压力: 'CTD02 Pressure',
    CTD03温度: 'CTD03 Temperature',
    CTD03电导率: 'CTD03 Conductivity',
    CTD03压力: 'CTD03 Pressure',
    CTD04温度: 'CTD04 Temperature',
    CTD04电导率: 'CTD04 Conductivity',
    CTD04压力: 'CTD04 Pressure',
    CTD05温度: 'CTD05 Temperature',
    CTD05电导率: 'CTD05 Conductivity',
    CTD05压力: 'CTD05 Pressure',
    'NORTEK-E-speed': 'NORTEK-E-speed',
    'NORTEK-N-speed': 'NORTEK-N-speed',
    'NORTEK-U-speed': 'NORTEK-U-speed',
    'NORTEK-BEAM1': 'NORTEK-BEAM1',
    'NORTEK-BEAM2': 'NORTEK-BEAM2',
    'NORTEK-BEAM3': 'NORTEK-BEAM3',
    'NORTEK-PRESS': 'NORTEK-PRESS',
    'NORTEK-TEMP': 'NORTEK-TEMP',
    'NORTEK-SPEED': 'NORTEK-SPEED',
    'NORTEK-DIR': 'NORTEK-DIR',
    水下CO2: 'CO2 in water',
    '水下CO2-ppm': 'CO2 in water -ppm',
    '水上CO2-μmol/mol': 'CO2 in air -μmol/mol',
    水听器01: 'Hydrophone 01',
    水听器02: 'Hydrophone 02',
    水听器03: 'Hydrophone 03',
    水听器04: 'Hydrophone 04',
    水听器05: 'Hydrophone 05',
    水听器06: 'Hydrophone 06',
    水听器07: 'Hydrophone 07',
    水听器08: 'Hydrophone 08',
    水听器09: 'Hydrophone 09',
    水听器10: 'Hydrophone 10',
    水听器11: 'Hydrophone 11',
    水听器12: 'Hydrophone 12',
    水听器13: 'Hydrophone 13',
    水听器14: 'Hydrophone 14',
    水听器15: 'Hydrophone 15',
    水听器16: 'Hydrophone 16',
    水听器17: 'Hydrophone 17',
    水听器18: 'Hydrophone 18',
    水听器19: 'Hydrophone 19',
    水听器20: 'Hydrophone 20',
    水听器21: 'Hydrophone 21',
    水听器22: 'Hydrophone 22',
    水听器23: 'Hydrophone 23',
    水听器24: 'Hydrophone 24',
    水听器25: 'Hydrophone 25',
    水听器26: 'Hydrophone 26',
    水听器27: 'Hydrophone 27',
    水听器28: 'Hydrophone 28',
    '高程（米）': 'Elevation（m）',
    pitch: 'pitch',
    roll: 'roll',
    'X流速cm/s': 'X Flow Rate cm/s',
    'Y流速cm/s': 'Y Flow Rate cm/s',
    '流速cm/s': 'Flow Rate cm/s',
    '方位°': 'Position°',
    '流向°': 'Flow Direction°',
    'N/S流速cm/s': 'N/S Flow Rate cm/s',
    'E/W流速cm/s': 'E/W Flow Rate cm/s',
    保留字段: 'Reserve Fields',
    '溶解氧（mg/L）': 'Dissolved Oxygen（mg/L）',
    '液位值（mm）': 'Liquid Level（mm）',
    硝酸盐: 'Nitrate',
    亚硝酸盐: 'Nitrite',
    氨氮: 'Ammonia Nitrogen',
    磷酸盐: 'Phosphate',
    硅酸盐: 'Silicate',
    硝酸盐I0: 'Nitrate I0',
    硝酸盐I1: 'Nitrate I1',
    亚硝酸盐I0: 'Nitrite I0',
    亚硝酸盐I1: 'Nitrite I1',
    氨氮I0: 'Ammonia Nitrogen I0',
    氨氮I1: 'Ammonia Nitrogen I1',
    磷酸盐I0: 'Phosphate I0',
    磷酸盐I1: 'Phosphate I1',
    硅酸盐I0: 'Silicate I0',
    硅酸盐I1: 'Silicate I1',
    bWeek: 'bWeek',
    bTow: 'bTow',
    bLon: 'bLon',
    bLat: 'bLat',
    bH: 'bH',
    bWaveH: 'bWaveH',
    bWaveT: 'bWaveT',
    bZtd: 'bZtd',
    TD11温度: 'TD11 Temperature',
    TD11压力: 'TD11 Pressure',
    TD12温度: 'TD12 Temperature',
    TD12压力: 'TD12 Pressure',
    TD13温度: 'TD13 Temperature',
    TD13压力: 'TD13 Pressure',
    TD14温度: 'TD14 Temperature',
    TD14压力: 'TD14 Pressure',
    TD15温度: 'TD15 Temperature',
    TD15压力: 'TD15 Pressure',
    TD16温度: 'TD16 Temperature',
    TD16压力: 'TD16 Pressure',
    TD17温度: 'TD17 Temperature',
    TD17压力: 'TD17 Pressure',
    TD18温度: 'TD18 Temperature',
    TD18压力: 'TD18 Pressure',
    TD19温度: 'TD19 Temperature',
    TD19压力: 'TD19 Pressure',
    TD20温度: 'TD20 Temperature',
    TD20压力: 'TD20 Pressure',
    TD21温度: 'TD21 Temperature',
    TD21压力: 'TD21 Pressure',
    TD22温度: 'TD22 Temperature',
    TD22压力: 'TD22 Pressure',
    TD23温度: 'TD23 Temperature',
    TD23压力: 'TD23 Pressure',
    TD24温度: 'TD24 Temperature',
    TD24压力: 'TD24 Pressure',
    TD25温度: 'TD25 Temperature',
    TD25压力: 'TD25 Pressure',
    TD26温度: 'TD26 Temperature',
    TD26压力: 'TD26 Pressure',
    TD27温度: 'TD27 Temperature',
    TD27压力: 'TD27 Pressure',
    TD28温度: 'TD28 Temperature',
    TD28压力: 'TD28 Pressure',
    TD29温度: 'TD29 Temperature',
    TD29压力: 'TD29 Pressure',
    TD30温度: 'TD30 Temperature',
    TD30压力: 'TD30 Pressure',
    TD31温度: 'TD31 Temperature',
    TD31压力: 'TD31 Pressure',
    TD32温度: 'TD32 Temperature',
    TD32压力: 'TD32 Pressure',
    TD33温度: 'TD33 Temperature',
    TD33压力: 'TD33 Pressure',
    TD34温度: 'TD34 Temperature',
    TD34压力: 'TD34 Pressure',
    TD35温度: 'TD35 Temperature',
    TD35压力: 'TD35 Pressure',
    表层温度: 'Surface Humidity',
    表层盐度: 'Surface Salinity',
    波向02: 'Wave Direction 02',
    '水深01（m）': 'Depth 01（m）',
    '水深02（m）': 'Depth 02（m）',
    定位状态: 'Positioning Status',
    '1/3 Wave Height(m)': '1/3 Wave Height(m)',
    '1/3 Wave Period(s)': '1/3 Wave Period(s)',
    '1/10 Wave Height(m)': '1/10 Wave Height(m)',
    '1/10 Wave Period(s)': '1/10 Wave Period(s)',
    'Max Wave Height(m)': 'Max Wave Height(m)',
    'Max Wave Period(s)': 'Max Wave Period(s)',
    'Mean Wave Height (m)': 'Mean Wave Height (m)',
    'Mean Wave Period (s)': 'Mean Wave Period (s)',
    'Surge Wave Height (m)': 'Swell Wave Height',
    'Surge Wave Period (s)': 'Swell Wave Period',
    'Wave Direction': 'Wave Direction',
    'Surface Temp (℃)': 'Surface Temp (℃)',
    'voltage value (V)': 'voltage value (V)',
    Longtitude: 'Longtitude',
    Latitude: 'Latitude',
    'Wind Direction': 'Wind Direction',
    'Wind Speed (m/s)': 'Wind Speed (m/s)',
    'Air Pressure(hPa)': 'Air Pressure(hPa)',
    'Relative humidity': 'Relative humidity',
    'Temp(℃)': 'Temp(℃)',
    '电导率(mS/cm)': 'Conductivity(mS/cm)',
    '温度(℃)': 'Temperature(℃)',
    '浊度(NTU)': 'Turbidity(NTU)',
    '叶绿素a(μg/L)': 'chlorophyll a(μg/L)',
    报表: 'report',
    请完善查询条件: 'Please complete the query conditions',
    北礵三米测浪浮标: 'Three-metre Wave Buoy At North Shuang',
    时间1: 'Date',
    气压1: 'AP',
    波高1: 'WH',
    波周期1: 'WP',
    '24h最大': '24h Max',
    '24h最大风速': '24h Max Wind Speed',
    最大风速: 'Max Wind Speed',
    最大风向: 'Max Wind Direction',
    '24h最大波高': '24h Max Wave Height',
    最新: 'Up To Date',
    时间2: 'Date Time',
    时间3: 'Date & Time',
    '波高0~1米': 'Wave Height 0~1 m',
    '波高1~2米': 'Wave Height 1~2 m',
    '波高2~3米': 'Wave Height 2~3 m',
    海洋监测系统动态数据显示平台: 'Ocean Monitor System Dynamic Data Display Platform',
    'Currents Velocity01(mm/s)': 'Currents Velocity01(mm/s)',
    'Currents Velocity02(mm/s)': 'Currents Velocity02(mm/s)',
    'Currents Velocity03(mm/s)': 'Currents Velocity03(mm/s)',
    'Currents Velocity04(mm/s)': 'Currents Velocity04(mm/s)',
    'Currents Velocity05(mm/s)': 'Currents Velocity05(mm/s)',
    'Currents Velocity06(mm/s)': 'Currents Velocity06(mm/s)',
    'Currents Velocity07(mm/s)': 'Currents Velocity07(mm/s)',
    'Currents Velocity08(mm/s)': 'Currents Velocity08(mm/s)',
    'Currents Velocity09(mm/s)': 'Currents Velocity09(mm/s)',
    'Currents Velocity10(mm/s)': 'Currents Velocity10(mm/s)',
    'Currents Velocity11(mm/s)': 'Currents Velocity11(mm/s)',
    'Currents Velocity12(mm/s)': 'Currents Velocity12(mm/s)',
    'Currents Velocity13(mm/s)': 'Currents Velocity13(mm/s)',
    'Currents Velocity14(mm/s)': 'Currents Velocity14(mm/s)',
    'Currents direction01(°)': 'Currents direction01(°)',
    'Currents direction02(°)': 'Currents direction02(°)',
    'Currents direction03(°)': 'Currents direction03(°)',
    'Currents direction04(°)': 'Currents direction04(°)',
    'Currents direction05(°)': 'Currents direction05(°)',
    'Currents direction06(°)': 'Currents direction06(°)',
    'Currents direction07(°)': 'Currents direction07(°)',
    'Currents direction08(°)': 'Currents direction08(°)',
    'Currents direction09(°)': 'Currents direction09(°)',
    'Currents direction10(°)': 'Currents direction10(°)',
    'Currents direction11(°)': 'Currents direction11(°)',
    'Currents direction12(°)': 'Currents direction12(°)',
    'Currents direction13(°)': 'Currents direction13(°)',
    'Currents direction14(°)': 'Currents direction14(°)'
  },
  report: {
    首页: '首页',
    设备报表: '设备报表',
    筛选条件: '筛选条件',
    请选择设备类型: '请选择设备类型',
    请选择设备: '请选择设备',
    请设备参数: '请设备参数',
    开始日期: '开始日期',
    至: '至',
    结束日期: '结束日期',
    生成报表图: '生成报表图',
    选择了: '选择了',
    请完善查询条件: '请完善查询条件',
    报表: '报表'
  },
  allExcelData: {
    首页: '首页',
    数据批量导出: '数据批量导出',
    筛选条件: '筛选条件',
    数据开始日期: '数据开始日期',
    数据结束日期: '数据结束日期',
    至: '至',
    批量导出: '批量导出',
    压缩中: '压缩中',
    全选: '全选',
    请选择导出内容: '请选择导出内容',
    时间: '时间',
    经度: '经度',
    纬度: '纬度',
    正在导出: '正在导出',
    问题数据: '问题数据：'
  },
  dashBoard: {
    首页: '首页'
  },
  home: {
    激活设备: '激活设备',
    修改密码: '修改密码',
    退出登录: '退出登录',
    排序方式: '排序方式',
    设备编码: '设备编码',
    设备名称: '设备名称',
    我的设备: '我的设备',
    检索设备: '检索设备',
    数据批量导出: '数据批量导出',
    设备报表: '设备报表',
    地图: '地图',
    波谱: '波谱',
    广告机: '广告机',
    看板: '看板',
    其它设备: '其它设备',
    noData: '暂无数据',
    title: '海洋监测系统',
    登录成功: '登录成功',
    登录失败: '登录失败',
    看板1: '看板'
  },
  Monitoring5638: {
    '1/3波高': '1/3 WH (m)',
    '1/3波周期': '1/3 WP (s)',
    风速: 'WS (m/s)',
    风向: 'WD (°)',
    温度: 'Temp (°C)',
    湿度: 'Hum (°C)',
    气压: 'AP (hPa)'
  },
  Monitoring1025: {
    banner: '海洋监测系统动态数据展示平台',
    bouyName: '浮标名称',
    utcTime: '数据时间(UTC)',
    meteoData: '气象数据',
    humidity: '湿度',
    pressure: '大气压力',
    windSpeed: '风速',
    temp: '温度',
    hydroData: '水文数据',
    waveHeight: '海浪高度',
    waveDirection: '海浪方向',
    wavePeriod: '海浪周期',
    surfaceTemp: '表面水温',
    currentVelocity: '当前流速',
    currentDirection: '当前流向',
    waveGrade: '海浪等级',
    surfaceCurrent: '表面流速',
    historyData: '历史数据',
    timeSlot: '时间段',
    startTime: '开始',
    endTime: '结束',
    confirm: '确定',
    element: '要素',
    windDirection: '风向',
    airPressure: '大气压力',
    currentSpeedProfile: '当前流速',
    alarm: '报警数据',
    time: '时间',
    type: '类型',
    content: '内容',
    waveRoseDiagram: '波浪玫瑰图',
    currentSpeed: '当前流速',
    overSideAlarm: '位移偏移报警',
    leakWaterAlarm: '开仓漏水报警',
    timeOutAlarm: '超时报警',
    outLimitAlarm: '上下限报警',
    errorDataAlarm: '数据异常报警',

    overSideAlarmContent: '设备位置偏移{0}米，请注意设备的运行安全。',
    leakWaterAlarmContent: '设备有漏水的危险。请注意设备的运行安全。',
    timeOutAlarmContent: '设备信息无法正常返回。请注意设备是否正常运行。',
    outLimitAlarmContent: '设备{0}已{1}{2}，请注意设备的测量情况。',
    errorDataAlarmContent: '设备数据异常。请检查设备运行状态'
  }
}
